import './single_dimension_view.js.coffee'

Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.HierarchicalDimensionView extends CustomerVisualMode.Charts.SingleDimensionView
  template_path: JST['backbone/templates/monitoring/charts/tree_path']
  HIERARCHICAL_TAG_ROOT = null

  initialize: ({widget, data, barMenu, dataFormatter, dataTranslator, chartView, sortDropdown, session, isReadOnly, isResponsive}) ->
    super({widget, data, barMenu, dataFormatter, dataTranslator, chartView, sortDropdown, session, isReadOnly, isResponsive})
    attribute = @_attribute(session)
    tags = attribute.get('hierarchical_tags').tags
    @hierarchicalTags = new AccountSettings.ConversationAttributes.HierarchicalTagCollection(tags)
    currentCode = @_currentTagCode()
    @currentPath = if currentCode == HIERARCHICAL_TAG_ROOT then [] else @hierarchicalTags.pathTo(currentCode)

  render: ->
    super()
    @_renderCurrentPath()
    @

  _renderCurrentPath: ->
    @$el.find('.path').html(@template_path(tree_path: @_currentPathDescription()))
    @$el.find('.path .subpath').click((event) => @_onSubpathClick(event))

  _onSubpathClick: (event) ->
    subpathName = event.target.innerHTML.trim()
    clickedSubpath = @currentPath.find((hierarchicalTag) -> hierarchicalTag.get('description') == subpathName)
    newCode = if clickedSubpath == undefined then HIERARCHICAL_TAG_ROOT else clickedSubpath.get('code')
    @_updateTagLevel(newCode)

  _deepInto: (hierarchicalTagCode) ->
    @_updateTagLevel(hierarchicalTagCode) unless hierarchicalTagCode == @_missingValue()

  _updateTagLevel: (newTagCode) ->
    return if @isReadOnly || newTagCode == @_currentTagCode()
    @$el.find('.processing').removeClass('d-none')
    @$el.find('.single-dimension-chart').addClass('d-none')
    currentPath = if newTagCode == HIERARCHICAL_TAG_ROOT then [] else @hierarchicalTags.pathTo(newTagCode)
    @widget.updateHierarchicalLevel(newTagCode, (data) =>
      @$el.find('.processing').addClass('d-none')
      @$el.find('.single-dimension-chart').removeClass('d-none')
      @data = data
      @currentPath = currentPath
      @_updateChartData()
      @_renderChart()
      @_renderCurrentPath()
    )

  _currentPathDescription: ->
    @currentPath.map((hierarchicalTag) -> hierarchicalTag.get('description'))

  _onChartClick: (elementValue) =>
    return if elementValue == @_deletedValueCode()
    if @inClickWindowTime
      clearTimeout(@delayed_timeout)
      @_deepInto(elementValue)
      @inClickWindowTime = false
    else
      @delayed_timeout = setTimeout((=>
        @inClickWindowTime = false
        @_openDrilldown(elementValue)), 400
      )
      @inClickWindowTime = true

  _openDrilldown: (drilldownValue) ->
    extendedData = {
      hierarchical_tags_options: {
        code: drilldownValue,
        level: @currentPath.length + if @_currentTagHasChildren() then 1 else 0
      }
    }
    super(drilldownValue, extendedData)

  _currentTagCode: ->
    @widget.get('hierarchical_tags_options').code

  _currentTagHasChildren: ->
    currentHierarchicalTag = @currentPath.slice(-1)[0]
    return true unless currentHierarchicalTag

    currentHierarchicalTag.get('children').length > 0

  _deletedValueCode: ->
    'deleted values'
